import React from 'react'

const UserHistory = () => {
  return (
    <div>UserHistory</div>
  )
}

export default UserHistory